module.exports = __webpack_public_path__ + "img/mexicoCity.d561f61c.jpg";